import http from './httpRequest';

const action = (name, callId, groupId) => http({
  url: '/webrtc/group/' + name,
  method: 'post',
  params: { callId, groupId }
});

export default class RtcGroupApi {
  setup(groupId, userInfos) {
    return http({ url: '/webrtc/group/setup', method: 'post', data: { groupId, userInfos } });
  }
  invite(callId, groupId, userInfos) {
    return http({ url: '/webrtc/group/invite', method: 'post', data: { callId, groupId, userInfos } });
  }
  failed(callId, groupId, reason) {
    return http({ url: '/webrtc/group/failed', method: 'post', data: { callId, groupId, reason } });
  }
  device(callId, groupId, isCamera, isMicroPhone, isShareScreen) {
    return http({ url: '/webrtc/group/device', method: 'post', data: { callId, groupId, isCamera, isMicroPhone, isShareScreen } });
  }
  accept(callId, groupId) { return action('accept', callId, groupId); }
  reject(callId, groupId) { return action('reject', callId, groupId); }
  join(callId, groupId) { return action('join', callId, groupId); }
  quit(callId, groupId) { return action('quit', callId, groupId); }
  cancel(callId, groupId) { return action('cancel', callId, groupId); }
  heartbeat(callId, groupId) { return action('heartbeat', callId, groupId); }
  credentials(callId, groupId) { return action('credentials', callId, groupId); }
  ready(callId, groupId) { return action('ready', callId, groupId); }
}
